/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cms.asset.versions.rpc.ModuleUpdateRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getModulesToUpdateRpc = {
  serviceName: 'com.hubspot.cms.asset.versions.rpc.ModuleUpdateRpc',
  rpcName: 'getModulesToUpdate',
  auth: 'app',
  fingerprint: 'kjpuMuKwqATmvgesiPtCoZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateModulesRpc = {
  serviceName: 'com.hubspot.cms.asset.versions.rpc.ModuleUpdateRpc',
  rpcName: 'updateModules',
  auth: 'app',
  fingerprint: 'mjXMxXB_gciYELZYadF2iJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectionsRpc = {
  serviceName: 'com.hubspot.cms.asset.versions.rpc.ModuleUpdateRpc',
  rpcName: 'getConnections',
  auth: 'app',
  fingerprint: '_s6Jo5mISCdq5hZtjGfwz5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalAssetVersionInfoRpc = {
  serviceName: 'com.hubspot.cms.asset.versions.rpc.ModuleUpdateRpc',
  rpcName: 'getPortalAssetVersionInfo',
  auth: 'app',
  fingerprint: 'DqytmkKNTClN7EMg8tYk75wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};